import { useThemeData } from '@msrceng/theme';
/**
 * Creates a style set to make rendered HTML within a div look good.
 */
export const useInjectedHtmlStyles = () => {
    var _a;
    const { theme } = useThemeData();
    return {
        marginBottom: '0.25em',
        table: {
            boxShadow: (_a = theme.effects) === null || _a === void 0 ? void 0 : _a.elevation4,
        },
        'td,th': {
            padding: '1em',
            borderStyle: 'hidden',
        },
        h1: {
            marginTop: '0.3rem',
            marginBottom: '0.3rem',
        },
        blockquote: {
            padding: '0.15rem 0.5rem',
            marginInlineStart: '0.55rem',
            borderLeft: `4px solid ${theme.palette.greenLight}`,
            ':first-child': {
                marginTop: '0',
            },
        },
        code: {
            display: 'inline-block',
            padding: '0.25rem',
            background: theme.palette.neutralLighter,
            border: `1px double ${theme.palette.neutralSecondaryAlt}`,
            borderRadius: theme.effects.roundedCorner2,
        },
        p: {
            marginBlockStart: '0.45em',
            marginBlockEnd: '0.45em',
        },
    };
};
